import React from 'react';
import {connect} from 'react-redux';
import {urlParam} from '../../../../utils';
import WrongUser from '../../../wrong-user';
import InvalidLinkPage from '../../../invalid-link-page';
import WaitingPanelPage from '../../../waiting-panel-page';
import i18n from '../../../../../i18n';
import {I18nextProvider} from 'react-i18next';
import NewRegisterTemplate from '../new-register-template';
import InvitationResponse from '../../../../screens/invitation-response';

class NotRegisteredTemplate extends React.Component {
	render() {
		return (
			<I18nextProvider i18n={i18n}>
				{
					urlParam('page')
					?
						urlParam('page') === "wrong-invited-user"
						?
							<WrongUser userEmail={urlParam('email')}/>
						:
							urlParam('page') === "invalid-link"
							?
								<InvalidLinkPage/>
							:
								this.props.profile.status.includes('invited') === false
								?
										<NewRegisterTemplate/>
								:
									<WaitingPanelPage/>
						:
						this.props.profile.status.includes('invited') === false
						?
								<NewRegisterTemplate/>
						:
							window.location.pathname === '/invited/invitation-response'
							?
								<InvitationResponse />
							:
								<WaitingPanelPage/>
				}
			</I18nextProvider>
		)
	}
}

const mapStateToProps = state => ({
	language : state.languageReducer.language,
	isChromeExtInstalled: state.profileReducer.isChromeExtInstalled,
	profile : state.profileReducer.getProfile
});

export default connect(mapStateToProps)(NotRegisteredTemplate);
